<template>
	<form v-on:submit.prevent="validateBeforeSubmit">
		<div class="form-group">
			<ejs-combobox v-model="data.processId" id="process" :dataSource='dataSourceProcesses' :fields='fieldsSourceProcesses' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textReports.textFormProcess')"></ejs-combobox>
		</div>
		<ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtn" :disabled="disabledButton" :spinSettings="spinSettings" :progress="progress" :duration="50000">{{ $t('textBtn.btnSearch') }}</ejs-progressbutton>
	</form>
</template>

<script>
import axios from 'axios'
export default {
	name: "reports-form-processes",
	props: ['tittle'],
	data(){
		return {
			data: {
				processId : null,
			},
			dataSourceProcesses: [],
			fieldsSourceProcesses: { text: "nombre", value: 'id' },
			spinSettings: { position: 'Right', width: 20 },
			disabledButton :false,
			responseReport: false,
			activeFilters: []
		}
	},
	methods: {
		initFormProcesses: function() {
			this.dataSourceProcesses = [];
			axios.post('/auth/reports/getInitFormProcesses').then(response => {
				this.dataSourceProcesses = response.data;
			});
		},
		validateBeforeSubmit: function() {
			this.disabledButton = true;
			this.responseReport = false;
			this.$refs.progressBtn.enable;
			axios.post('/auth/reports/getReportsProcesses', {
				processId: this.data.processId,
			}).then(response => {
				var processSelect = document.getElementById('process').ej2_instances[0].itemData;
				if(this.data.processId !== null && this.data.processId !== "")  this.activeFilters.push('Proceso - ' + processSelect.nombre);
				this.responseReport = true;
				Vue.prototype.$eventHub.$emit('loadDataReports', this.$props.tittle, response.data, this.activeFilters.join("/"));
			});
		},
		progress: function() {
			if(this.responseReport){
				this.$refs.progressBtn.stop();
			}
		}
	},
	created: function() {
		this.initFormProcesses();
		this.$eventHub.$on('onResetSwitchTenants', this.initFormProcesses);
	}
}
</script>